export const faqs = [
    {
        question: "Can I settle my L&T Finance Two-Wheeler Loan?",
        answer: "Yes, if you are unable to pay the EMIs due to financial loss, job loss, or medical emergencies, L&T Finance may agree to a One Time Settlement (OTS). This usually happens after the loan has been classified as a Non-Performing Asset (NPA)."
    },
    {
        question: "What happens if I default on my Tractor Loan?",
        answer: "Tractor loans are secured loans. L&T Finance has the right to repossess the tractor if you default. However, we can help you negotiate a restructuring of the loan or a settlement to prevent repossession, especially if the default is due to crop failure or genuine hardship."
    },
    {
        question: "Does L&T Finance file arbitration cases?",
        answer: "Yes, L&T Finance frequently uses arbitration clauses in their loan agreements. They may appoint an arbitrator to pass an award for the recovery of the dues. It is critical to attend these proceedings or have a lawyer represent you to ensure a fair outcome."
    },
    {
        question: "Can I settle a Microfinance (Micro Loan) group loan?",
        answer: "Microfinance loans (JLG loans) are often given to groups. While individual settlement is possible, it can be complex due to group liability. We can help negotiate an individual settlement if you are facing specific personal hardships."
    },
    {
        question: "How much discount can I get in an OTS?",
        answer: "For unsecured loans (like personal or consumer durable loans), settlements can range from 40% to 60% waiver on the outstanding amount. For secured loans (Two-wheeler/Tractor), the discount is generally lower as the lender can sell the asset, but we can still negotiate waiver of penal interest and charges."
    },
    {
        question: "Will they seize my bike if I miss EMIs?",
        answer: "They cannot seize your vehicle without following due legal process. They must give you notice. If agents are threatening to seize your bike by force, it is illegal. We can intervene to stop this harassment."
    },
    {
        question: "What is the impact on my CIBIL score?",
        answer: "Settling a loan will mark the account as 'Settled' in your credit report, which drops your score. However, this is a better alternative to a 'Written Off' status or ongoing default, which damages your score more severely."
    },
    {
        question: "Can I pay the settlement amount in installments?",
        answer: "Typically, OTS requires a lump-sum payment. However, in genuine cases, we can negotiate with L&T Finance to allow payment in 2-3 installments over a short period."
    },
    {
        question: "What documents do I need for settlement?",
        answer: "You will need your loan account number, ID proof (PAN/Aadhaar), and documents proving your financial hardship (e.g., income loss proof, medical records, crop loss report for farmers)."
    },
    {
        question: "Is the settlement letter valid?",
        answer: "We ensure that you receive a formal settlement letter from L&T Finance on their official letterhead before you make any payment. This letter serves as proof that the loan is closed upon payment."
    },
    {
        question: "Can I get a loan again after settlement?",
        answer: "It will be difficult to get a loan immediately. You will need to rebuild your credit score for 12-24 months using secured credit cards or small loans before you become eligible again."
    },
    {
        question: "Why should I hire AMA Legal Solutions?",
        answer: "We have extensive experience dealing with L&T Finance's legal and recovery teams. We know their processes and can get you the best possible deal while protecting you from harassment and legal complications."
    },
    {
        question: "What if I have received a legal notice?",
        answer: "Do not ignore it. A legal notice is the first step towards court action or arbitration. Send it to us immediately so we can reply to it legally and initiate settlement talks."
    },
    {
        question: "Can I settle a Housing Loan with L&T Finance?",
        answer: "Yes, but since it is a secured loan, the bank will prefer to sell the property. Settlement is possible if the property value has fallen or if you can arrange a lump sum close to the principal amount. We can help analyze your specific case."
    },
    {
        question: "Do I need to visit the branch?",
        answer: "In most cases, we handle the negotiations remotely. You may only need to visit for the final payment or to collect the No Dues Certificate."
    }
];
